module.exports = __webpack_public_path__ + "static/share-session-cover-c2d0389f9f5b3f332c49ee98ffd8dd39.png";